import { useItemsCount } from "../../../fetch/fetch.item.ts";

const ItemCount = ({ categorySlug }: { categorySlug: string }) => {
  const { count } = useItemsCount({ categorySlug: categorySlug });
  return count;
};
export default ItemCount;
